import i18next from 'i18next'
import { eraseCookie, getCookie } from '../cookie/cookieHandlers'

const signInBtns = document.querySelectorAll('[data-sign-in-btn]')
const loginedUserElms = document.querySelectorAll('[data-logined-user-elm]')
const userInfoText = document.querySelectorAll('[data-user-info-text]')
const logOutBtns = document.querySelectorAll('[data-logout-btn]')

const userBurgerInfoBlock = document.querySelector('[data-user-burger]')

i18next.on('loaded', function () {
  checkIfUserAuthorized()
})

logOutBtns?.forEach(e =>
  e?.addEventListener('click', event => {
    event.preventDefault()
    logoutBtnHandler()
  }),
)

function checkIfUserAuthorized() {
  const sessionIdFromCookies = getCookie('sessionId')
  if (sessionIdFromCookies) {
    getUserData(sessionIdFromCookies)
  }
}

function getUserData(sessId) {
  const formDataUser = new FormData()

  formDataUser.append('func', 'whoami')
  formDataUser.append('out', 'json')
  formDataUser.append('auth', sessId)

  fetch(`${process.env.BILLING_URL}`, {
    method: 'POST',
    body: formDataUser,
  })
    .then(response => response.json())
    .then(data => {
      if (data?.doc?.error) {
        logout()
        throw new Error(data.doc.error.msg?.$)
      }

      if (data?.doc?.path?.$name) {
        login(data.doc.path.$name)
      }
    })
    .catch(err => console.log(err.message))
}

function logout() {
  loginedUserElms.forEach(el => el.classList.remove('shown'))
  userBurgerInfoBlock.style.display = 'none'
  userBurgerInfoBlock.classList.remove('opened')

  signInBtns?.forEach(e => e.classList.add('shown'))
  eraseCookie('sessionId')
}

function login(name) {
  signInBtns?.forEach(e => e.classList.remove('shown'))
  loginedUserElms.forEach(el => el.classList.add('shown'))
  userBurgerInfoBlock.style.display = 'flex'

  userInfoText?.forEach(e => (e.innerHTML = name))
}

function logoutBtnHandler() {
  const sessionId = getCookie('sessionId')

  if (sessionId) {
    const formDataUserLogout = new FormData()
    formDataUserLogout.append('func', 'logon')
    formDataUserLogout.append('out', 'json')
    formDataUserLogout.append('auth', sessionId)

    fetch(`${process.env.BILLING_URL}`, {
      method: 'POST',
      body: formDataUserLogout,
    })

    logout()
  }
}
